import {
    startOfDay, endOfDay,
    startOfWeek, endOfWeek,
    startOfMonth, endOfMonth,
    subDays, subWeeks, subMonths,
    formatISO,
} from 'date-fns'


const periodToDate = ({scale, period}) => {
    const offset = Math.abs(period)
    const now = new Date()

    let anchor
    switch (scale) {
        case 'day':
            anchor = subDays(now, offset)
            return {
                from: formatISO(startOfDay(anchor)),
                to: formatISO(endOfDay(anchor)),
            }
        case 'week':
            anchor = subWeeks(now, offset)
            return {
                from: formatISO(startOfWeek(anchor, {weekStartsOn: 1})),
                to: formatISO(endOfWeek(anchor, {weekStartsOn: 1})),
            }
        case 'month':
            anchor = subMonths(now, offset)
            return {
                from: formatISO(startOfMonth(anchor)),
                to: formatISO(endOfMonth(anchor)),
            }
        default:
            return {}
    }
}

export { periodToDate }

